import { DiamondPlus, Funnel, OctagonMinus } from 'lucide-react';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useRef } from 'react';

import QuickFilters from './QuickFilters';

const QuickFiltersPanel = ({
  isForChart,
  selectedTable,
  selectedChartTable,
  action,
  showQuickFilters,
  setShowQuickFilters,
  copyFilter,
  widgetFormik,
  dimensionList,

  quickFilterFor,
}) => {
  const overlayRef = useRef(null);
  const headerTemplate = () => {
    return (
      <div className="flex align-items-center gap-2 text-sm font-medium text-gray-700">
        <div className="col align-items-center justify-content-start gap-2 flex">
          <Funnel className="text-primary text-sm w-1rem h-1rem" />

          <span className="text-sm font-bold text-gray-500">
            Quick Filters <span className="text-red-400">*</span>
          </span>
          <OverlayPanel
            ref={overlayRef}
            pt={{
              content: { className: 'p-1 text-sm' },
              root: { className: 'shadow-3' },
            }}
          >
            Use Quick Filters to narrow down your data.
            <br /> Select a field, pick an operator, and optionally compare it
            with another field of the same type.
          </OverlayPanel>

          <i
            className="pi pi-info-circle text-sm text-primary cursor-pointer"
            onMouseEnter={e => overlayRef.current.show(e)}
          />
          {selectedTable === selectedChartTable && (
            <Button
              size="small"
              onClick={() => copyFilter()}
              label={isForChart ? 'Copy from Report' : 'Copy from Chart'}
              outlined
            ></Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <Panel header={headerTemplate} className="w-full">
      <div className="grid grid-nogutter gap-2">
        {action !== 'view' && (
          <>
            {showQuickFilters ? (
              <Button
                disabled={
                  isForChart
                    ? widgetFormik.values.quick_filter_chart_conditions
                        ?.filters?.[0]?.fields?.[0]?.tableField &&
                      showQuickFilters
                    : widgetFormik.values.quick_filter_report_conditions
                        ?.filters?.[0]?.fields?.[0]?.tableField &&
                      showQuickFilters
                }
                icon={<OctagonMinus className="text-sm w-1rem h-1rem" />}
                pt={{ label: { className: 'pl-1 text-xs' } }}
                label="Remove Filter Condition"
                className={`border-round-md py-2`}
                onClick={() => {
                  if (isForChart) {
                    if (
                      !(
                        widgetFormik.values.quick_filter_chart_conditions?.[0]
                          ?.tableField && showQuickFilters
                      )
                    ) {
                      setShowQuickFilters(false);
                    }
                  } else {
                    if (
                      !(
                        widgetFormik.values.quick_filter_report_conditions?.[0]
                          ?.tableField && showQuickFilters
                      )
                    ) {
                      setShowQuickFilters(false);
                    }
                  }
                }}
              />
            ) : (
              <Button
                icon={<DiamondPlus className="text-sm w-1rem h-1rem" />}
                label="Add New Filter Condition"
                pt={{ label: { className: 'pl-1 text-xs' } }}
                className={`border-round-md py-2`}
                onClick={() => {
                  widgetFormik.setFieldValue('quick_filter_chart_conditions', [
                    { tableField: '', operator: '', compareWithField: '' },
                  ]);

                  widgetFormik.setFieldValue('quick_filter_report_conditions', [
                    { tableField: '', operator: '', compareWithField: '' },
                  ]);
                  setShowQuickFilters(true);
                }}
              />
            )}
          </>
        )}
        {showQuickFilters && (
          <QuickFilters
            widgetFormik={widgetFormik}
            filterConditions={
              isForChart
                ? widgetFormik.values.quick_filter_chart_conditions
                : widgetFormik.values.quick_filter_report_conditions
            }
            dimensionList={dimensionList}
            quickFilterFor={quickFilterFor}
          />
        )}
      </div>
    </Panel>
  );
};

export default QuickFiltersPanel;
